export default __webpack_public_path__ + "static/media/mar2024-5.d94080e9.jpg";